





































































































































































































































































































































































































import {
  defineComponent,
  ref,
  PropType,
  computed,
  watch,
  onMounted,
  onUnmounted,
} from "@vue/composition-api";
import { Product } from "~/modules/catalog/product/types";
import { getName as getProductName } from "~/modules/catalog/product/getters/productGetters";
import useWishlist from "~/modules/wishlist/composables/useWishlist";
import SkeletonLoader from "~/components/SkeletonLoader/index.vue";
import {
  getLableSaleColor,
  getPromotionImageDetail,
  getPromotionImageLink,
  getCampainProductDetail,
  copyCode,
  checkHttpLink,
  changeImage,
} from "~/helpers";
import { useFlashSale } from "~/composables/useFlashSale";
import { useConfigStore } from "~/stores/extensionApi";
import { useUiNotification } from "~/composables/useUiNotification";
import { useUser } from "~/modules/customer/composables/useUser";
import { getPrices } from "~/modules/catalog/product/getters/productGetters";

export default defineComponent({
  name: "ProductInfo",
  components: {
    SkeletonLoader,
  },
  props: {
    product: {
      type: [Object, null] as PropType<Product>,
      default: null,
    },
    productShowPrice: {
      type: [Object, null] as PropType<Product>,
      default: null,
    },
    isAuthenticate: {
      type: Boolean,
      default: false,
    },
    isFetching: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const { addOrRemoveItem, isInWishlist } = useWishlist();
    const {
      getFlashSaleProductBySku,
      flashSaleProduct,
      loading: loadingFlashSale,
      getCampaignConfig,
      isCampaignActive,
      getCountdownTimeInSeconds,
      getCountdownDate,
      campaignConfig,
      campaignConfigLoading,
    } = useFlashSale();

    const storeConfig = useConfigStore();
    const campainImage = computed(() => storeConfig.getCampaignBannerImage);
    const countdownImage = computed(() => storeConfig.getCountdownImage);

    const flashDealConfigImage = computed(
      () => storeConfig.getFlashDealConfig?.image_deal_detail
    );

    const soldQuantity = computed(() => {
      if (!flashSaleProduct.value) return 0;
      return flashSaleProduct.value.sale_qty + flashSaleProduct.value.fake_qty;
    });

    const flashSalePercentage = computed(() => {
      if (!flashSaleProduct.value) return 0;
      const totalQty =
        flashSaleProduct.value.deal_qty + flashSaleProduct.value.fake_qty;
      const soldQty =
        flashSaleProduct.value.sale_qty + flashSaleProduct.value.fake_qty;

      return Math.round((soldQty * 100) / totalQty);
    });

    const { isAuthenticated } = useUser();
    const { send: sendNotification } = useUiNotification();

    const handleWishlistClick = () => {
      if (!isAuthenticated.value) {
        sendNotification({
          id: Symbol("login_required"),
          type: "danger",
          message: "Đăng nhập để thêm yêu thích",
          icon: "error",
          persist: false,
          title: "Yêu cầu đăng nhập",
        });
        return;
      }
      addOrRemoveItem({ product: props.product });
    };

    const wishlistState = computed(() =>
      isInWishlist({ product: props.product })
    );

    const labelSaleColor = computed(() => {
      if (props.product) {
        return getLableSaleColor(props.product.labels_sales);
      }
      return null;
    });

    const imagePromotion = computed(() => {
      if (props.product) {
        return getPromotionImageDetail(props.product.promotion_image_detail);
      }
      return null;
    });

    const imageLink = computed(() => {
      if (props.product) {
        return (
          props.product?.promotion_url_path ||
          getPromotionImageLink(props.product?.promotion_image_detail)
        );
      }
      return null;
    });

    const campainProduct = computed(() => {
      if (props.product) {
        return getCampainProductDetail(props.product.campaign);
      }
      return null;
    });

    const countdownTime = ref({
      hours: "00",
      minutes: "00",
      seconds: "00",
    });

    const days = ref(0);

    const countdownInterval = ref<any>(null);

    const updateCountdown = () => {
      if (flashSaleProduct.value && flashSaleProduct.value.remaining_time) {
        let remainingMs = flashSaleProduct.value.remaining_time;

        // If remaining time is more than 0, calculate and update the countdown
        if (remainingMs > 0) {
          // Calculate days
          const daysValue = Math.floor(remainingMs / (1000 * 60 * 60 * 24));
          remainingMs -= daysValue * 1000 * 60 * 60 * 24;

          const hours = Math.floor(remainingMs / (1000 * 60 * 60));
          remainingMs -= hours * 1000 * 60 * 60;

          const minutes = Math.floor(remainingMs / (1000 * 60));
          remainingMs -= minutes * 1000 * 60;

          const seconds = Math.floor(remainingMs / 1000);

          days.value = daysValue;
          countdownTime.value = {
            hours: hours.toString().padStart(2, "0"),
            minutes: minutes.toString().padStart(2, "0"),
            seconds: seconds.toString().padStart(2, "0"),
          };

          // Reduce remaining time by 1 second for next iteration
          flashSaleProduct.value.remaining_time -= 1000;
        } else {
          // Reset countdown when time is up
          days.value = 0;
          countdownTime.value = {
            hours: "00",
            minutes: "00",
            seconds: "00",
          };

          // Clear interval when countdown is finished
          if (countdownInterval.value) {
            clearInterval(countdownInterval.value);
          }
        }
      }
    };

    // Start countdown when flashSaleProduct is available
    watch(
      () => flashSaleProduct.value,
      (newValue) => {
        if (newValue && newValue.remaining_time) {
          // Clear existing interval if any
          if (countdownInterval.value) {
            clearInterval(countdownInterval.value);
          }

          // Initialize countdown immediately
          updateCountdown();

          // Set interval to update countdown every second
          countdownInterval.value = setInterval(updateCountdown, 1000);
        }
      },
      { immediate: true }
    );

    // Campaign countdown related refs and functions
    const campaignCountdownTime = ref({
      hours: "00",
      minutes: "00",
      seconds: "00",
    });

    const campaignDays = ref(0);
    const campaignCountdownInterval = ref<any>(null);

    const updateCampaignCountdown = () => {
      if (isCampaignActive()) {
        let remainingSeconds = getCountdownTimeInSeconds();
        if (remainingSeconds > 0) {
          // Calculate days
          const daysValue = Math.floor(remainingSeconds / (60 * 60 * 24));
          remainingSeconds -= daysValue * 60 * 60 * 24;

          // Calculate hours, minutes, seconds
          const hours = Math.floor(remainingSeconds / (60 * 60));
          remainingSeconds -= hours * 60 * 60;

          const minutes = Math.floor(remainingSeconds / 60);
          remainingSeconds -= minutes * 60;

          const seconds = remainingSeconds;

          campaignDays.value = daysValue;
          campaignCountdownTime.value = {
            hours: hours.toString().padStart(2, "0"),
            minutes: minutes.toString().padStart(2, "0"),
            seconds: seconds.toString().padStart(2, "0"),
          };

          // Update campaign config with 1 second less
          if (campaignConfig.value?.campaign?.countdown_time) {
            campaignConfig.value.campaign.countdown_time -= 1000;
          }
        } else {
          // Reset countdown when time is up
          campaignDays.value = 0;
          campaignCountdownTime.value = {
            hours: "00",
            minutes: "00",
            seconds: "00",
          };

          // Clear interval when countdown is finished
          if (campaignCountdownInterval.value) {
            clearInterval(campaignCountdownInterval.value);
          }
        }
      }
    };
    const copySku = () => {
      if (props.product && props.product.sku) {
        copyCode(props.product.sku);
        sendNotification({
          id: Symbol("copy-sku"),
          message: "Đã sao chép mã sản phẩm " + props.product.sku,
          type: "success",
          icon: "check",
          persist: false,
        });
      }
    };
    const shareProduct = () => {
      if (navigator.share) {
        const shareData = {
          title: props.product?.name || "",
          text:
            props.product?.short_description?.html || props.product?.name || "",
          url: window.location.href,
        };

        navigator
          .share(shareData)
          .then(() => {
            console.log("Shared successfully");
          })
          .catch((error) => {
            console.error("Error sharing:", error);
            // Fallback in case Web Share API fails
            copyToClipboard();
          });
      } else {
        copyToClipboard();
      }
    };

    // Separate function for copying to clipboard
    const copyToClipboard = () => {
      try {
        // Create temporary input to copy the URL
        const tempInput = document.createElement("input");
        tempInput.value = window.location.href;
        document.body.appendChild(tempInput);
        tempInput.select();
        document.execCommand("copy");
        document.body.removeChild(tempInput);

        sendNotification({
          id: Symbol("share-product-detail"),
          message: "Đã sao chép đường dẫn sản phẩm vào clipboard",
          type: "success",
          icon: "check",
          persist: false,
        });
      } catch (error) {}
    };
    // Handle campaign config
    onMounted(async () => {
      await getCampaignConfig();

      // Start campaign countdown if campaign is active and type is countdown
      if (isCampaignActive() && campainProduct.value === "countdown") {
        // Initialize countdown immediately
        updateCampaignCountdown();

        // Set interval to update countdown every second
        campaignCountdownInterval.value = setInterval(
          updateCampaignCountdown,
          1000
        );
      }
    });

    // Clean up all intervals when component is destroyed
    onUnmounted(() => {
      if (countdownInterval.value) {
        clearInterval(countdownInterval.value);
      }
      if (campaignCountdownInterval.value) {
        clearInterval(campaignCountdownInterval.value);
      }
    });

    // Clean up interval when component is destroyed
    onUnmounted(() => {
      if (countdownInterval.value) {
        clearInterval(countdownInterval.value);
      }
    });

    // Fetch flash sale product data when product changes
    watch(
      () => props.product?.sku,
      (newProduct) => {
        if (newProduct && newProduct) {
          getFlashSaleProductBySku(newProduct);
        }
      },
      { immediate: true }
    );

    return {
      getProductName,
      handleWishlistClick,
      addItemToWishlist: addOrRemoveItem,
      wishlistState,
      getLableSaleColor,
      labelSaleColor,
      flashSaleProduct,
      flashSalePercentage,
      soldQuantity,
      countdownTime,
      loadingFlashSale,
      days,
      flashDealConfigImage,
      imagePromotion,
      campainProduct,
      campainImage,
      countdownImage,
      isCampaignActive,
      campaignDays,
      campaignCountdownTime,
      copySku,
      shareProduct,
      getPrices,
      imageLink,
      checkHttpLink,
      changeImage,
    };
  },
});
